export default __webpack_public_path__ + "static/media/372.87290760.png";